import { render, staticRenderFns } from "./AppTextArea.vue?vue&type=template&id=9b0c5df6"
import script from "./AppTextArea.vue?vue&type=script&lang=js"
export * from "./AppTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports